export default __webpack_public_path__ + "static/media/orderProduct.9a4e95e4.png";